<h3>Denuncias</h3>

<div class="flex flex-row gap-8 h-full">

  <div class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center">
    <span>Pendientes de admisión</span>
    <h2>{{ pendingAdmission ?? 0 }}</h2>
  </div>

  <div class="bg-neutral shadow-e1 h-full p-3 flex flex-col gap-1 justify-center">
    <span class="cd-text-lg text-lg">Pendientes de resolución</span>
    <h2>{{ pendingResolution ?? 0 }}</h2>
  </div>

</div>

<button (click)="goToComplaints()" class="btn btn-primary flex flex-row gap-2 items-center"
        style="border-radius: 0.5rem;width:11rem;padding: 0.5rem">
  <img alt="Complaints" class="filter-neutral-100 h-4" src="/assets/icons/feather/clipboard.svg">
  <span class="cd-text-md truncate">Ver denuncias</span>
</button>
